export default "__VITE_ASSET__DmWkArP3__"